import { RouterProvider } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { SnackbarProvider } from 'notistack';
import { Suspense } from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { cs } from 'date-fns/locale';
import { router } from '@/app/routes.tsx';
import { AuthProvider } from '@/app/common/context/AuthContext.tsx';
import { AccountProvider } from '@/app/common/context/AccountContext.tsx';
import { ErrorDialogProvider } from '@/app/common/context/ErrorDialogContext.tsx';
import { ApiErrorDialog } from '@/app/common/components/ApiErrorDialog.tsx';
import { theme } from '@/app/theme.ts';
import LoadingSpinner from '@/app/common/components/LoadingSpinner.tsx';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={cs}>
      <SnackbarProvider maxSnack={3} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
        <ErrorDialogProvider>
          <ApiErrorDialog />
          <AuthProvider>
            <AccountProvider>
              <Suspense fallback={<LoadingSpinner />}>
                <RouterProvider router={router} />
              </Suspense>
            </AccountProvider>
          </AuthProvider>
        </ErrorDialogProvider>
      </SnackbarProvider>
    </LocalizationProvider>
    </ThemeProvider>
  );
}

export default App;
